$('.products-slider .slider').slick({
    arrows: true,
    appendArrows: '.products-slider .arrows',
    infinite: true,
    slide: '.products-slider .slide',
    autoplay: true,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 4,
    responsive: [
        {
            breakpoint: 900,
            settings: {
                centerMode: true,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 630,
            settings: {
                centerMode: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                centerMode: true,
                slidesToShow: 1
            }
        }
    ]
});